import {
  Box,
  Button,
  Container,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';
import { SidebarUnauthenticated } from './SidebarUnauthenticated';
import { ToggleButton } from './ToggleButton';

export const NavbarUnauthenticated = () => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Box as="nav" bg="bg-surface" zIndex={100} position="sticky" w="100%" top="0">
      <Container py={{ base: '3', lg: '5' }} maxW={'100%'} w="100%">
        <Flex justify="space-between">
          <HStack spacing="8">
            <Link to={ROUTES.dashboard}>
              <Image image="logo-black" width={['100px', '166px']} cursor="pointer" />
            </Link>
          </HStack>
          {isDesktop ? (
            <HStack alignItems={'center'} justifyContent={'center'}>
              <Button as={Link} to={ROUTES.signin} variant={'ghost'}>
                Sign In
              </Button>
            </HStack>
          ) : (
            <>
              <ToggleButton isOpen={isOpen} aria-label="Open Menu" onClick={onToggle} />
              <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                isFullHeight={true}
                preserveScrollBarGap={true}>
                <DrawerOverlay />
                <DrawerContent>
                  <SidebarUnauthenticated />
                </DrawerContent>
              </Drawer>
            </>
          )}
        </Flex>
      </Container>
    </Box>
  );
};
